import React, {useEffect, useState} from 'react';
import {FloatingBubble, IndexBar, List, SearchBar, Skeleton} from "antd-mobile/2x";
import {
  HTML_TITLE,
  PS_RELOAD_CLUE_LIST,
  PS_RELOAD_LINKMAN_LIST,
  URL_CLUE_CREATE,
  URL_CLUE_DETAIL,
  URL_CLUE_LIST,
} from "../../../constant";
import styles from "./ClueList.less"
import "./ClueList.css"
import {Query, Url} from "../../../api/query";
import ChineseHelper from "../../../utils/Pinyin/ChineseHelper";
import {AddOutline} from "antd-mobile-icons";
import {useHistory} from "react-router-dom";
import MyEmpty from "../../MyComponents/MyEmpty/MyEmpty";
import {GlobalZoom} from "../../../index";
import PubSub from "pubsub-js";

const QueryType = {
  MyType: "MyType",
  UnderlingType: "UnderlingType",
}

const tabKeys = ['0', '1']
let tabKey = tabKeys[0]

const ClueList = () => {
  useEffect(() => {
    document.title = HTML_TITLE[URL_CLUE_LIST]
    clueQuerySelf()

    const ps_reload_clue_list = PubSub.subscribe(PS_RELOAD_CLUE_LIST, () => {
      clueQuerySelf()
    })
    return () => {
      PubSub.unsubscribe(ps_reload_clue_list)
    }
  }, [])

  const history = useHistory();

  const [myList, setMyList] = useState([])
  const [myListLoading, setMyListLoading] = useState(false)
  const [myGroups, setMyGroups] = useState([])

  const clueQuerySelf = () => {
    setMyListLoading(true)
    Query(Url.clueQueryByUserId, null,
      (res) => {
        let list = res.data.list
        for (let i = 0; i < list.length; i++) {
          list[i]["enName"] = ChineseHelper.ConvertPinyin(list[i].name)
        }

        setMyList(list)
        setGroups(list)
        setMyListLoading(false)
      },
      (res) => {
        setMyListLoading(false)
      },
      () => {
        setMyListLoading(false)
      }
    )
  }

  const searchMyList = (value) => {
    const keyword = value.split('').filter((s) => s !== '' && s !== ' ');
    setGroups(myList.filter((item) => {
      let flag = true
      keyword.forEach((k) => {
        if (!item.name.includes(k)) {
          flag = false
        }
      })
      return flag
    }))
  }

  const setGroups = (list) => {
    list.sort((o1, o2) => o1.enName.localeCompare(o2.enName, 'en'))

    let lastInitial = '$'
    let groups = []
    for (let i = 0; i < list.length; i++) {
      const initial = list[i].enName.charAt(0)
      if (initial !== lastInitial) {
        lastInitial = initial
        groups.push({
          title: initial,
          items: []
        })
      }
      groups[groups.length - 1].items.push(list[i])
    }
    if (groups.length !== 0) {
      groups.push({
        title: '',
        items: []
      })
    }
    setMyGroups(groups)
  }

  const ListDiv = () => {
    let isLoading = false
    isLoading = myListLoading
    return (<div className={styles.body}>
      <div style={{margin: '20px 50px 20px 50px', display: isLoading ? 'block' : 'none'}}>
        <Skeleton.Title animated/>
        <Skeleton.Paragraph lineCount={5} animated/>
      </div>
      <div style={{margin: '80px 50px 20px 50px', display: !isLoading && myGroups.length <= 0 ? 'block' : 'none'}}>
        <MyEmpty/>
      </div>
      <IndexBar style={{display: (isLoading || myGroups.length <= 0) ? 'none' : 'block'}}>
        {myGroups.map(group => {
          const {title, items} = group
          return (
            <IndexBar.Panel index={title} title={title} key={title}>
              <List>
                {
                  items.map(listItem => (
                    <List.Item key={listItem.id} onClick={() => {
                      history.push({
                        pathname: URL_CLUE_DETAIL,
                        state: {clue: listItem}
                      })
                    }}>
                      {listItem.name}
                    </List.Item>
                  ))}
              </List>
            </IndexBar.Panel>
          )
        })}
      </IndexBar>
    </div>)
  }

  return (
    <div className={styles.clue_frame}>
      <div className={styles.body}>
        <FloatingBubble
          style={{
            '--initial-position-bottom': '24px',
            '--initial-position-right': '24px',
            '--edge-distance': '24px',
            '--size': '128px',
            '--z-index': '1000',
          }}
          onClick={() => {
            history.push(URL_CLUE_CREATE)
          }}
        >
          <div>
            <AddOutline fontSize={60 * GlobalZoom}/>
          </div>
        </FloatingBubble>


        <div className={styles.frame}>
          <div className={styles.top}>
            <div style={{margin: '10px 0 30px 0'}}>
              <SearchBar placeholder='查找我的线索' showCancelButton
                         onSearch={searchMyList}
                         onClear={() => {
                           setGroups(myList)
                         }}
                         onCancel={() => {
                           setGroups(myList)
                         }}
                         style={{'--height': '80px'}}
              />
            </div>
          </div>
          {ListDiv()}
        </div>
      </div>

    </div>
  );
};


export default ClueList;